import { FC } from 'react';
import type { IRecommendListDTO, IRecommendItemDTO } from './typings';
import { IRecommendItemType } from './typings';
import cls from 'classnames';
import styles from './index.module.less';
import mobxWrap from '@/components/MobxWrap';
import { SearchTracker } from '@/utils/Tracker';
import { TScene } from '../SearchBar/typings';
import { getPDPUrl } from '@/components/ProductCard/utils';
import { addSearchParam } from '@/utils/url';

export enum EnumRowFlexDirection {
  row = 'row',
  column = 'column',
}

interface Props {
  // 推荐数据
  data: IRecommendListDTO[];
  // 布局方向
  direction?: EnumRowFlexDirection;
  scene: `${TScene}-default`;
}

/** 推荐列表 */
const List: FC<IRecommendListDTO & { scene: Props['scene'] }> = ({ recommendItems, category, scene, type }) => {
  return (
    <div className={styles.list}>
      <span className={styles.title}>{category}</span>
      {recommendItems.map((item) => {
        const itemData = Object.assign(item, { type });
        return <Item {...itemData} key={item.text} scene={scene} />;
      })}
    </div>
  );
};

/** 推荐列表item */
const Item: FC<IRecommendItemDTO & { scene: Props['scene'] }> = (props) => {
  const { text, type, scene } = props;

  const isProduct = type === IRecommendItemType.Product;

  // 根据不同类型
  const redirectUrl = (() => {
    let targetUrl = '';
    if (isProduct) {
      targetUrl = getPDPUrl(
        // 构造sku
        {
          product: {
            urlKey: props.urlKey,
          },
          commodity: {
            commodityId: props.commodityId,
          },
        },
        scene
      );
    } else {
      targetUrl = addSearchParam({
        url: props.activityLink,
        param: 'from',
        value: scene,
      });
    }
    return targetUrl;
  })();

  // 跳转重定向
  const onRedirect = () => {
    window.location.href = redirectUrl;
  };

  return (
    <div
      className={styles.item}
      onClick={() => {
        SearchTracker.searchBarTracing({
          action: 'quick_link_click',
          labels:
            type === IRecommendItemType.Product
              ? {
                  redirectUrl,
                }
              : undefined,
        });
        onRedirect();
      }}
    >
      {text}
    </div>
  );
};

/** 推荐模块-纯UI组件 */
export const SearchRecommends: FC<Props> = ({ data, direction = EnumRowFlexDirection.row, scene }) => {
  // 行布局
  const isFlexRow = direction === EnumRowFlexDirection.row;
  if (data.length <= 0) return null;
  return (
    <div
      className={cls(
        styles.wrapper,
        isFlexRow ? styles.row : styles.column,
        scene === 'search-result-default' ? styles.searchResults : ''
      )}
    >
      {data.map((list) => {
        return <List {...list} key={list.category} scene={scene} />;
      })}
    </div>
  );
};

export const SearchRecommendsObserver = mobxWrap<Omit<Props, 'data'>, ['search']>(['search'], (props) => {
  const data = props.search.recommends;
  return <SearchRecommends data={data} direction={props.direction} scene={props.scene} />;
});

export default SearchRecommendsObserver;
